module.exports = __webpack_public_path__ + "static/media/invest-img.ebdf11a2.png";